/*!
 * Copyright (C) Design:Funedikly. All rights reserved.
 */

import * as React from 'react';

export const LinkedIn = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1_8)">
        <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M5.37142 0.666505C7.92808 0.668539 10.0367 2.81634 10.0314 5.42922C10.0254 8.16549 7.79275 10.2279 5.34008 10.1682C2.85208 10.2197 0.666082 8.1065 0.666748 5.41091C0.666748 2.79735 2.78341 0.664471 5.37142 0.666505Z" />
        <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M8.00001 39.3165H2.66668C1.95601 39.3165 1.33334 38.6894 1.33334 37.966V14.2419C1.33334 13.5185 1.89868 12.8812 2.61001 12.8812H8.00001C8.71068 12.8812 9.33334 13.5144 9.33334 14.2372V38.0073C9.33334 38.73 8.71068 39.3165 8.00001 39.3165Z" />
        <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M39.3336 21.1457C39.3336 16.1633 35.6529 12.2033 30.7529 12.2033H29.3483C26.6676 12.2033 24.0909 13.5145 22.6669 15.5931C22.1943 16.0738 22.0003 16.2711 22.0003 16.2711V13.5592C22.0003 13.2596 21.6289 12.8813 21.3336 12.8813H14.6669C14.3716 12.8813 14.0003 13.1755 14.0003 13.4758V38.7735C14.0003 39.0731 14.3716 39.3165 14.6669 39.3165L22.0003 39.3186C22.2956 39.3186 22.6669 39.0752 22.6669 38.7748V24.1599C22.6669 21.6338 24.5009 19.5362 26.9849 19.5077C28.2529 19.4928 29.4029 20.0101 30.2309 20.8528C31.0489 21.684 31.3336 22.8331 31.3336 24.1016V38.644C31.3336 38.9443 31.7049 39.322 32.0003 39.322H38.6669C38.9623 39.322 39.3336 38.9443 39.3336 38.644V21.1457Z" />
      </g>
      <defs>
        <clipPath id="clip0_1_8">
          <rect width="40" height="40" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}
